import { ShowcaseSlide } from "./types";

/** Koliko dugo je svaki slajd na ekranu (ms). */
export const LOGIN_SHOWCASE_SLIDE_MS = 5500;

export const LOGIN_SHOWCASE_SLIDES: ShowcaseSlide[] = [
  {
    id: "fleet",
    title: "Cijela flota na jednom mjestu",
    description: "Vozila, vozači i dokumenti su pregledni i uvijek pri ruci.",
  },
  {
    id: "documents",
    title: "Ponude, ugovori i računi",
    description: "Iz vozila napravite ponudu, pretvorite je u ugovor i izdajte račun u par koraka.",
  },
  {
    id: "service",
    title: "Servisi i troškovi pod kontrolom",
    description: "Podsjetnici za servis, gume i registraciju stižu na vrijeme.",
  },
];

